import { useEffect, useRef, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { Card, Checkbox, Button, Popover, Typography, Row } from 'antd'
import { Check, Edit, X } from 'react-feather'
import { setSynthesizerEnabled } from 'Actions/graph'

{ Paragraph, Text } = Typography


helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    Enables the synthesizer mode
  </Paragraph>
</div>)


SynthesizerPanel = ({ synthesizerEnabled, setSynthesizerEnabled }) ->

  <Card
    title="Synthesizer mode"
    size="small"
    id="Synthesizer mode"
  >
    <Row>
      <Checkbox
        style={{ marginRight: 5 }}
        onChange={({ target: { checked } }) ->
          setSynthesizerEnabled(checked)
        }
        checked={synthesizerEnabled}
      />
      Enable synthesizer in wvr.io?
    </Row>

  </Card>

export default connect(({ graph, projects }) ->
  {
    synthesizerEnabled: graph.synthesizerEnabled
  }
, {
    setSynthesizerEnabled
  })(SynthesizerPanel)
